/**
 * Who may read a location's site payment statement and transfer list, and whose transfers they see. One rule
 * for the Api routes and the Admin, so they cannot drift. Transfers, amounts and session lists are visible only
 * to the recipient's own roles and to EVI (ruling, 17 October 2026). Building Admin and Property Manager see
 * payments to the location's own bank account. Charger owner staff (untemplated tenant_admin, operator and
 * viewer, native or granted) see only payments routed to their own tenant's account, and a Charger Owner sees
 * them only when they own that tenant (the Api checks that). Super Admin, native or granted, sees both, each
 * labelled. Anyone else reads nothing.
 */
export const SITE_PAYMENT_SITE_TEMPLATES = ['building_admin', 'property_manager'];
export const SITE_PAYMENT_STAFF_ROLES = ['operator', 'viewer', 'tenant_admin'];
export function sitePaymentView(caller) {
    if (caller.role === 'super_admin' || caller.systemRole === 'super_admin')
        return 'all';
    if (caller.template)
        return SITE_PAYMENT_SITE_TEMPLATES.includes(caller.template) ? 'location'
            : caller.template === 'charger_owner' ? 'owner' : null;
    return SITE_PAYMENT_STAFF_ROLES.includes(caller.systemRole ?? caller.role ?? '') ? 'owner' : null;
}
//# sourceMappingURL=sitePaymentReaders.js.map